module.exports = __webpack_public_path__ + "images/65b966815c7a9f1ca670459ef94963c2-illu_imageSensor.svg";